import axios from 'axios';

/** RAG routes live at /rag (not under /api). */
const ragClient = axios.create({
  baseURL: '',
});

ragClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('ap_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

ragClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('ap_token');
      localStorage.removeItem('ap_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export async function getCurrentChatSession() {
  const { data } = await ragClient.get('/rag/sessions/current');
  return data;
}

export async function createChatSession() {
  const { data } = await ragClient.post('/rag/sessions');
  return data;
}

export async function getSessionMessages(sessionId) {
  const { data } = await ragClient.get(`/rag/sessions/${sessionId}/messages`);
  return data;
}

export async function postRagChat(question, sessionId) {
  const { data } = await ragClient.post('/rag/chat', {
    question,
    session_id: sessionId || undefined,
  });
  return data;
}

export async function postRagUpload(file, { documentId, sourceName, replace = false, sessionId }) {
  const form = new FormData();
  form.append('document_id', documentId);
  form.append('source_name', sourceName);
  form.append('file', file);
  if (replace) {
    form.append('replace', 'true');
  }
  if (sessionId) {
    form.append('session_id', sessionId);
  }
  const { data } = await ragClient.post('/rag/upload', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 300000,
  });
  return data;
}

export async function getRagHealth() {
  const { data } = await ragClient.get('/rag/health');
  return data;
}

export default ragClient;
